module.exports = __webpack_public_path__ + "6aa4c3358d572ff4b96e4a22e516ce2d.svg";